import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_BASE_ADMIN_API,
});

api.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response.status === 403 || error.response.status === 401) {
            localStorage.removeItem('clientToken');
            localStorage.removeItem('client');
            localStorage.removeItem('clientId'); 
            window.location.href = '/login'; 
        } 
        return Promise.reject(error);
    }
);

export default api;
